/**
 * Which question the call dialog is asking, or none when a call needs no question at all.
 *
 * Chosen when the call is requested, by showCallDialog in app-actions, and then only changed
 * by the user answering. Nothing derived from presence or call state may change it afterwards:
 * a colleague hanging up is not an answer (AC-1797).
 */
export const CallDialogType = {
    BUSY_EXTENSION: 'busyExtension',
    CALL_METHOD: 'callMethod',
} as const;

export type CallDialogType =
    (typeof CallDialogType)[keyof typeof CallDialogType];
